import { render, staticRenderFns } from "./ViewIdea.vue?vue&type=template&id=2ed6e07c&"
import script from "./ViewIdea.vue?vue&type=script&lang=js&"
export * from "./ViewIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports